module.exports = __webpack_public_path__ + "img/shape-2.df36cc62.svg";